import { Button, Checkbox, Col, Form, Input, Modal, notification, Row } from 'antd';
import { authApi } from 'api/authApi';
import { useAppSelector } from 'app/hooks';
import { registerInfo } from 'models';
import { useState } from 'react';
import { selectIsLoggedIn } from '../../authSlice';
import style from './Register.module.scss';
export interface RegisterProps {
  setItemSelect: (value: boolean) => void;
}
export default function Register(props: RegisterProps) {
  const [form] = Form.useForm();
  const { setItemSelect } = props;
  const isLogging = useAppSelector(selectIsLoggedIn);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [modalVisibleOne, setModalVisibleOne] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const onRegister = async (values: registerInfo) => {
    if (values.agreement) {
      try {
        const res = await authApi.register({
          email: values.email,
          first_name: values.first_name,
          last_name: values.last_name,
          phone: values.phone,
          // organization: values.organization,
        });
        setModalVisibleOne(true);
      } catch (error) {
        openNotificationWithIcon(
          'error',
          'Registration failed! Please double check your information. If still not, please contact us with hot line: 0236 3849468'
        );
      }
    } else {
      openNotificationWithIcon(
        'error',
        'Registration failed! Please double check your information. If still not, please contact us with hot line: 0236 3849468'
      );
    }
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 23,
        offset: 1,
      },
    },
  };

  return (
    <div className={style.form_login}>
      <Form
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={(values) => onRegister(values)}
        layout="vertical"
        hideRequiredMark
        initialValues={{ type: 'DEMO' }}
        onValuesChange={(changedValues, allValues) => {
          if (changedValues.agreement) {
            setIsDisabled(false);
          } else {
            setIsDisabled(true);
          }
        }}
      >
        <Form.Item
          label="Organization:"
          name="organization"
          rules={[{ required: true, message: 'Please input your information or company' }]}
        >
          <Input placeholder="Customer or Company" />
        </Form.Item>
        <Form.Item
          label="Email:"
          name="email"
          rules={[{ required: true, message: 'Please input your Email' }]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          label="Phone:"
          name="phone"
          rules={[{ required: true, message: 'Please input your Email' }]}
        >
          <Input placeholder="Phone Number" />
        </Form.Item>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="First name:"
              name="first_name"
              rules={[{ required: true, message: 'Please input First Name' }]}
            >
              <Input type="textarea" placeholder="First Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Last name:"
              name="last_name"
              rules={[{ required: true, message: 'Please input Last Name' }]}
            >
              <Input type="textarea" placeholder="Last Name" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="agreement" valuePropName="checked" {...tailFormItemLayout}>
          <Checkbox>
            Agree with our&nbsp;
            <span
              style={{
                color: '#1890ff',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
              onClick={() => setModalVisible(true)}
            >
              term of service and privacy policy
            </span>
          </Checkbox>
        </Form.Item>
      </Form>
      <div className={style.group_btn}>
        <Button
          shape="round"
          size={'large'}
          loading={isLogging}
          className={style.btn_login}
          onClick={() => form.submit()}
          disabled={isDisabled}
        >
          Request
        </Button>
      </div>
      <Modal
        title="Vertically centered modal dialog"
        centered
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        okText="Go to login"
      >
        <p>some contents...</p>
        <p>some contents...</p>
        <p>some contents...</p>
      </Modal>
      <Modal
        title="Successfully!"
        centered
        visible={modalVisibleOne}
        onOk={() => {
          setModalVisibleOne(false);
          setItemSelect(false);
        }}
        onCancel={() => {
          setModalVisibleOne(false);
        }}
      >
        <p style={{"fontSize": "1.1em"}}>
          <span>Thank you for your interest in our SolarFarm Service,</span>
          <br/>
          <span> Demo account information has been sent to your email, use it to login and experience SolarFarm software</span>
        </p>
        <p><b>Go to login page?</b></p>
      </Modal>
    </div>
  );
}
